<template>
    <brand-list-link :listLayout="listLayout" :brandData="List"></brand-list-link>
</template>

<script>
import brandUtil from "@/components/brand/brandUtil";
import alertMixins from "@/mixins/alertMixins";
import BrandListLink from "@/components/brand/link/BrandListLink.vue";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/mixins/event-bus";
export default {
    name: "BrandAdverComponent",
    mixins: [alertMixins, brandUtil],
    components: {BrandListLink,},
    inject: [],
    provide() {
        return {
            brandListDelete: this.runDeleteConfirm,
        }
    },
    props: {
        brandType: '',
        defaultParams: {default: () => {}},
        setListCount: {default: () => {}},
    },
    data() {
        return {
            listLayout: '',
            listApiParamSet: {},
            getFunc: '',

            keyName: '',

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,

            List: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig();
    },
    mounted() {
        this.getList();
        EventBus.$on('brandAdverGetList', this.getList)
    },
    beforeDestroy() {
        EventBus.$off('brandAdverGetList')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },

        initConfig() {
            let config = this.returnBrandConfig(this.brandType);
            this.listLayout = config.listLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;

            this.keyName = config.keyName

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
        },

        getList() {
            let params = Object.assign({}, this.listApiParamSet, this.defaultParams);
            try {
                this.$api.$brand[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.List = res.List;
                        this.setListCount(this.List.length);
                    }
                })
            }catch (e) {
                console.log(e);
            }
        },

        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$brand[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDeleteConfirm(key) {

            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: (value) => {
                    this.runDelete(key);
                },
                cancel: () => {
                }
            })
        },

        runDelete(key, value) {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(key)
        },

        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.getList();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
